import dayjs from "dayjs"
import { times } from "lodash-es"
import { RRule } from "rrule"

export const FREQUENCY_OPTIONS = [
  { name: "Daily", id: RRule.DAILY, unit: "day" },
  { name: "Weekly", id: RRule.WEEKLY, unit: "week" },
  { name: "Monthly", id: RRule.MONTHLY, unit: "month" },
  { name: "Yearly", id: RRule.YEARLY, unit: "year" },
]

export const TENURE_OPTIONS = [
  { name: "Half Month", id: "half_month", days: 15 },
  { name: "Monthly", id: "monthly", days: 30 },
  { name: "Quarterly", id: "quarterly", days: 90 },
  { name: "Semi Annual", id: "semiannual", days: 180 },
  { name: "Custom", id: "custom" },
]

export const WEEKDAYS = [
  { name: "Mon", id: RRule.MO },
  { name: "Tue", id: RRule.TU },
  { name: "Wed", id: RRule.WE },
  { name: "Thu", id: RRule.TH },
  { name: "Fri", id: RRule.FR },
  { name: "Sat", id: RRule.SA },
  { name: "Sun", id: RRule.SU },
]

export const DAYS = times(31).map(time => ({
  name: dayjs()
    .set("month", 4)
    .set("date", time + 1)
    .format("Do"),
  id: time + 1,
}))

export const MONTHS = times(12).map(time => ({
  name: dayjs().set("month", time).format("MMM"),
  id: time + 1,
}))

const demoRule =
  "RRULE:FREQ=WEEKLY;BYDAY=MO,TU\nRRULE:FREQ=WEEKLY;BYDAY=WE,TH\nRRULE:FREQ=WEEKLY;BYDAY=FR,SA\nRRULE:FREQ=MONTHLY"
export const demoRules = demoRule.split("\n").map(rule => {
  return {
    rule: RRule.fromString(rule),
    type: rule.slice(0, rule.indexOf(":")) as any,
  }
})
